import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=72f9d034&"
import script from "./PaymentsList.vue?vue&type=script&lang=js&"
export * from "./PaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f9d034')) {
      api.createRecord('72f9d034', component.options)
    } else {
      api.reload('72f9d034', component.options)
    }
    module.hot.accept("./PaymentsList.vue?vue&type=template&id=72f9d034&", function () {
      api.rerender('72f9d034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/PaymentsList.vue"
export default component.exports